import { Component, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FooterComponent } from 'shared/components/shared/footer/footer.component';
import { ToastItem } from 'projects/shared/lib/components/shared/toast/item/toast-item.model';
import { EToastItemType } from 'projects/shared/lib/enum/toast/toast-entry-type.enum';
import { ServiceLocator } from 'projects/shared/lib/services/infrastructure/service-locator.service';
import { FooterHeightService } from '../../../services/ui/footerHeight.service';
import { MobileDetectionService } from 'projects/shared/lib/services/ui/mobile-detection.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-footer',
  imports: [
    CommonModule,
    RouterModule,
  ],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterMHComponent extends FooterComponent {

  private footerHeightService: FooterHeightService;
  private mobileDetectionService: MobileDetectionService;
  private orientationSubscription: Subscription | undefined;

  constructor(private elRef: ElementRef) {
    super();
    this.footerHeightService = ServiceLocator.injector.get(FooterHeightService);
    this.mobileDetectionService = ServiceLocator.injector.get(MobileDetectionService);
  }

  ngAfterViewInit() {
    this.updateFooterHeight();
    this.orientationSubscription = this.mobileDetectionService.orientation$.subscribe(
      (orientation: string) => {
        this.updateFooterHeight();
      }
    );
  }

  public ngOnDestroy(): void {
    this.orientationSubscription?.unsubscribe();
  }

  private updateFooterHeight() {
    let rect = this.elRef.nativeElement.getBoundingClientRect();
    let height = rect.height;
    this.footerHeightService.setFooterHeight(height);
  }

  public logout() {
    this.userService.userLogout().subscribe({
      next: () => {
        this.authService.accessJWTClear();

        this.toastService.toastItemAdd(new ToastItem({
          type: EToastItemType.Success,
          title: $localize`:@@NavFooterMenuLogoutSuccessToastTitle:Logout successful`,
        }));

        this.router.navigate([this.anonymousLandingPage.routerlink], { queryParams: this.anonymousLandingPage.queryParams });
      },
      error: (error) => {
        this.logger.error(error, this.constructor.name);
        this.toastService.toastItemAdd(new ToastItem({
          type: EToastItemType.Danger,
          title: $localize`:@@NavFooterMenuLogoutErrorToastTitle:Logout failed`,
          code: JSON.parse(error.response).errorCode
        }));
      },
      complete: () => { }
    });
  }

}
